<!--
	Legend panel for the AADT module: AADT bands, Traffic counts.
-->
<script lang="ts">
	import { PATCH_FALLBACK } from '#lib/vizPalette.js';
	import LegendPatch from '#lib/components/LegendPatch.svelte';
	import LegendRow from '#lib/components/LegendRow.svelte';
	import AbleyButton from '#lib/components/AbleyButton.svelte';
	import LegendSection from '#lib/components/LegendSection.svelte';
	import DataNotAvailable from '#lib/components/DataNotAvailable.svelte';
	import { legendStore } from '#lib/stores/legendStore.svelte.js';
	import { ELinksCore } from '../interfaces';

	const aadtLegend = $derived(legendStore.layers.find((l) => l.systemId === ELinksCore.Aadt));
	const countsLegend = $derived(legendStore.layers.find((l) => l.systemId === ELinksCore.Counts));
</script>

<div class="legendBox">
	<LegendSection heading="AADT bands (vehicles per day)">
		{#if !aadtLegend}
			<DataNotAvailable />
		{:else}
			{#each aadtLegend.legendItems as { color, label, legendItemId, enabled } (legendItemId)}
				<div class="legendRowBox">
					<LegendRow
						{label}
						checked={enabled}
						onchange={() =>
							legendStore.setLegendLayerVisibility({
								layerId: aadtLegend.layerId,
								legendItemId,
								enabled: !enabled
							})}>
						<LegendPatch color={color ?? PATCH_FALLBACK} shape="square" />
					</LegendRow>
				</div>
			{/each}
			<AbleyButton
				variant="text"
				size="xs"
				onclick={() =>
					legendStore.setAllLegendLayerVisibility({
						layerId: aadtLegend.layerId,
						enabled: !aadtLegend.layerAllEnabled
					})}>
				{aadtLegend.layerAllEnabled ? 'Select none' : 'Select all'}
			</AbleyButton>
		{/if}
	</LegendSection>

	<LegendSection heading="Traffic counts">
		{#if !countsLegend}
			<DataNotAvailable />
		{:else}
			<div class="legendRowBox">
				<LegendRow
					label="Count site"
					checked={countsLegend.layerAllEnabled}
					onchange={() =>
						legendStore.setAllLegendLayerVisibility({
							layerId: countsLegend.layerId,
							enabled: !countsLegend.layerAllEnabled
						})}>
					<LegendPatch color={countsLegend.legendItems[0].color ?? PATCH_FALLBACK} shape="round" />
				</LegendRow>
			</div>
		{/if}
	</LegendSection>
</div>
